/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import store, { moduleActionContext, moduleGetterContext } from "@/store";
import { CriterionBase } from "@/models/api/filters/criterions/CriterionBase";
import {
  checkRequireDataToGenerateDocument,
  cloneOrder,
  editDocument,
  editOrder,
  getBookingItemsToConvert,
  getContractorAvailableProjects,
  getTemporaryComment,
  getTemporaryContractorMonit,
  getTemporaryContractors,
  getTemporaryCorrectionReason,
  getTemporaryOrder,
  getTemporaryOrderItemMonit,
  getTemporaryOrderItems,
  getTemporaryOwners,
  getUnavailableCashiers,
  postSaveOrder,
  setTemporaryOnOrder,
  updateOrderTemporary,
} from "@/requests/order/orderAddEdit";
import BaseCommand from "@/models/api/commands/BaseCommand";
import { TemporaryContractor } from "@/models/api/orders/temporary/OrderGetTemporaryContractors";
import { OrderGetTemporaryOrderSection } from "@/models/api/orders/temporary/OrderGetTemporaryOrderSection";
import {
  OrderGetTemporaryOwner,
  OrderGetTemporaryOwnersResponse,
} from "@/models/api/orders/temporary/OrderGetTemporaryOwners";
import {
  OrderGetTemporaryOrderItemsResponse,
  OrderItemPart,
} from "@/models/api/orders/temporary/OrderGetTemporaryOrderItems";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import { FILTER_NAMES } from "@/static/filterNames";
import { DataOptions } from "vuetify/types";
import { RELOAD_TYPES } from "@/static/reloadTypes";
import dayjs from "dayjs";
import OrderAddEditCommandsModule from "@/store/modules/orders/orderAddEdit/commands";
import TradeTermsModule from "@/store/modules/orders/orderAddEdit/tradeTerms";
import OrderAddEditOrderItemModule from "@/store/modules/orders/orderAddEdit/orderItem";
import { OrderMonit } from "@/models/api/orders/temporary/OrderGetTemporaryMonit";
import routerInstance from "@/plugins/router";
import SelectItem from "@/models/components/inputs/selectItem";
import { CommandResponseTradeTermIsPercentage, OperationResult } from "@/models/api/orders/OperationResult";
import { ORDER_EDITOR_REASON } from "@/static/orderEditorReason";
import AdvanceDocumentModule from "@/store/modules/orders/orderAddEdit/advanceDocument";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { BookingItemToImport } from "@/models/api/orders/BookingItemToImport";
import { Owner } from "@/models/api/Owner";
import _ from "lodash";
import { UpdateCorrectionReasonParams } from "@/models/api/commands/order/UpdateCorrectionReasonCommand";
import { Monit } from "@/models/components/popup/Monit";
import { ConfirmModel } from "@/models/components/popup/Confirm";
import { filterCapitalize } from "@/filters/capitalize";
import i18n from "@/plugins/i18n";
import { CONTRACTOR_TYPES } from "@/static/contractorTypes";
import { ORDER_CONTRACTOR_TABS } from "@/static/orderContractorTabs";
import { CHANGE_REASON } from "@/static/changeReasonEnum";

export interface OrderAddEditStateInterface {
  filter: Array<CriterionBase>;
  currenciesList: null;
  buyer: null | TemporaryContractor;
  payer: null | TemporaryContractor;
  receiver: null | TemporaryContractor;
  seller: null | TemporaryContractor;
  contractor: null | TemporaryContractor;
  organizationalUnit: null | TemporaryContractor;
  bankAccounts: null;
  defaultBankAccount: null;
  printers: null;
  contractorFilter: Array<CriterionBase>;
  serviceTypes: null;
  settings: null;
  sessionId: null | string;
  operationId: null | string;
  comment: null | string;
  changeReasonDescription: null | string;
  internalChangeReasonId: null | CHANGE_REASON;
  formalCorrectionBefore: string | null;
  formalCorrectionAfter: string | null;
  monit: null | string;
  orderSection: null | OrderGetTemporaryOrderSection;
  owners: Array<OrderGetTemporaryOwner>;
  orderItemsDataOptions: DataOptions;
  isOrderItemsLoading: boolean;
  orderItems: Array<OrderItemPart>;
  orderItemsFilter: Array<CriterionItemRequest>;
  orderItemsCount: number | null;
  isOrderItemPositionDialog: boolean;
  orderItemPositionId: string | null;
  orderItemPositionCurrent: number | null;
  summary: string;
  contractorMonit: null | OrderMonit;
  isContractorMonitVisible: boolean;
  orderItemMonit: null | OrderMonit;
  isOrderItemMonitVisible: boolean;
  orderId: string | null;
  isUnsavedChanges: boolean;
  contractorAvailableProjects: Array<SelectItem> | null;
  isImportBookingsDialog: boolean;
  isImportBookingAttributesDialog: boolean;
  orderItemIdToImportAttributes: null | string;
  updateOrderTemporaryQuery: Array<BaseCommand>;
  isUpdateOrderTemporaryProcessing: boolean;
  bookingItemsToImport: Array<BookingItemToImport>;
  isBookingItemsConversionDialog: boolean;
  isPreview: boolean;
  isServicePackageDialog: boolean;
  cashiers: Array<Owner>;
  orderMonit: Monit;
  isViewLoading: boolean;
  tab: ORDER_CONTRACTOR_TABS;
}

export const OrderAddEditState: OrderAddEditStateInterface = {
  serviceTypes: null,
  settings: null,
  bankAccounts: null,
  contractorFilter: [],
  defaultBankAccount: null,
  printers: null,
  buyer: null,
  organizationalUnit: null,
  payer: null,
  receiver: null,
  seller: null,
  contractor: null,
  filter: [],
  currenciesList: null,
  sessionId: null,
  operationId: null,
  comment: "",
  changeReasonDescription: null,
  internalChangeReasonId: null,
  formalCorrectionBefore: null,
  formalCorrectionAfter: null,
  monit: null,
  orderSection: null,
  owners: [],
  orderItemsDataOptions: new DefaultDataOptions(),
  isOrderItemsLoading: false,
  orderItems: [],
  orderItemsFilter: Array<CriterionItemRequest>(),
  orderItemsCount: null,
  isOrderItemPositionDialog: false,
  orderItemPositionId: null,
  orderItemPositionCurrent: null,
  summary: "",
  contractorMonit: null,
  isContractorMonitVisible: false,
  orderItemMonit: null,
  isOrderItemMonitVisible: false,
  orderId: null,
  isUnsavedChanges: false,
  contractorAvailableProjects: null,
  isImportBookingsDialog: false,
  isImportBookingAttributesDialog: false,
  orderItemIdToImportAttributes: null,
  updateOrderTemporaryQuery: Array<BaseCommand>(),
  isUpdateOrderTemporaryProcessing: false,
  bookingItemsToImport: [],
  isBookingItemsConversionDialog: false,
  isPreview: false,
  isServicePackageDialog: false,
  cashiers: [],
  orderMonit: {
    items: [],
  },
  isViewLoading: false,
  tab: ORDER_CONTRACTOR_TABS.BUYER,
};

const OrderAddEditModule = defineModule({
  modules: {
    commands: OrderAddEditCommandsModule,
    tradeTerms: TradeTermsModule,
    orderItem: OrderAddEditOrderItemModule,
    advanceDocument: AdvanceDocumentModule,
  },
  state: OrderAddEditState as OrderAddEditStateInterface,
  namespaced: true as const,
  getters: {
    isFromSaleDate(...args): boolean {
      const { state } = _moduleGetterContext(args); // eslint-disable-line
      return state.orderSection !== null && state.orderSection.isFromSaleDate;
    },
    paymentDaysCount(...args): string {
      const { state, getters } = _moduleGetterContext(args); // eslint-disable-line
      if (state.orderSection === null) return "0";
      let baseDate;
      if (getters.isFromSaleDate) {
        baseDate = dayjs(state.orderSection.saleDate, "YYYY/MM/DD");
      } else {
        baseDate = dayjs(state.orderSection.issueDate, "YYYY/MM/DD");
      }
      return (-1 * baseDate.diff(dayjs(state.orderSection.paymentDate, "YYYY/MM/DD"), "day")).toString();
    },
    minDate(...args): string | undefined {
      const { getters, state } = _moduleGetterContext(args); // eslint-disable-line
      if (getters.isFromSaleDate) return state.orderSection?.saleDate;
      return state.orderSection?.issueDate;
    },
  },
  mutations: {
    resetState(state) {
      state.serviceTypes = null;
      state.settings = null;
      state.bankAccounts = null;
      state.contractorFilter = [];
      state.defaultBankAccount = null;
      state.printers = null;
      state.buyer = null;
      state.organizationalUnit = null;
      state.payer = null;
      state.receiver = null;
      state.seller = null;
      state.contractor = null;
      state.filter = [];
      state.currenciesList = null;
      state.sessionId = null;
      state.operationId = null;
      state.comment = "";
      state.changeReasonDescription = null;
      state.internalChangeReasonId = null;
      state.monit = null;
      state.orderSection = null;
      state.owners = [];
      state.orderItemsDataOptions = new DefaultDataOptions();
      state.isOrderItemsLoading = false;
      state.orderItems = [];
      state.orderItemsFilter = Array<CriterionItemRequest>();
      state.orderItemsCount = null;
      state.isOrderItemPositionDialog = false;
      state.orderItemPositionId = null;
      state.orderItemPositionCurrent = null;
      state.summary = "";
      state.contractorMonit = null;
      state.isContractorMonitVisible = false;
      state.orderItemMonit = null;
      state.isOrderItemMonitVisible = false;
      state.orderId = null;
      state.isUnsavedChanges = false;
      state.contractorAvailableProjects = null;
      state.isImportBookingsDialog = false;
      state.isImportBookingAttributesDialog = false;
      state.orderItemIdToImportAttributes = null;
      state.updateOrderTemporaryQuery = Array<BaseCommand>();
      state.isUpdateOrderTemporaryProcessing = false;
      state.bookingItemsToImport = [];
      state.isBookingItemsConversionDialog = false;
      state.isPreview = false;
      state.isServicePackageDialog = false;
      state.cashiers = [];
      state.orderMonit = {
        items: [],
      };
      state.isViewLoading = false;
      state.tab = ORDER_CONTRACTOR_TABS.BUYER;
    },
    setSessionId(state, param: string | null) {
      state.sessionId = param;
      state.operationId = param;
    },
    setOperationId(state, param: string | null) {
      state.operationId = param;
    },
    setPayer(state, param: TemporaryContractor) {
      state.payer = param;
    },
    setSeller(state, param: TemporaryContractor) {
      state.seller = param;
    },
    setBuyer(state, param: TemporaryContractor) {
      state.buyer = param;
    },
    setOrganizationalUnit(state, param: TemporaryContractor) {
      state.organizationalUnit = param;
    },
    setReceiver(state, param: TemporaryContractor) {
      state.receiver = param;
    },
    setContractor(state, param: TemporaryContractor | null) {
      state.contractor = param;
    },
    setComment(state, comment: string) {
      state.comment = comment;
    },
    setCorrectionReason(state, params: UpdateCorrectionReasonParams) {
      state.internalChangeReasonId = params.InternalChangeReasonId;
      state.changeReasonDescription = params.ChangeReasonDescription;
    },
    setChangeReasonDescription(state, changeReasonDescription: null | string) {
      state.changeReasonDescription = changeReasonDescription;
    },
    setInternalChangeReasonId(state, internalChangeReasonId: null | CHANGE_REASON) {
      state.internalChangeReasonId = internalChangeReasonId;
    },
    setFormalCorrectionBefore(state, formalCorrectionBefore: string | null) {
      state.formalCorrectionBefore = formalCorrectionBefore;
    },
    setFormalCorrectionAfter(state, formalCorrectionAfter: string | null) {
      state.formalCorrectionAfter = formalCorrectionAfter;
    },
    setMonit(state, monit: string) {
      state.monit = monit;
    },
    setOrderSection(state, param: OrderGetTemporaryOrderSection) {
      state.orderSection = param;
    },
    setOwners(state, param: OrderGetTemporaryOwnersResponse) {
      state.owners = param;
    },
    setOrderItems(state, param: OrderGetTemporaryOrderItemsResponse) {
      state.orderItems = param.items;
      state.summary = param.summary;
    },
    setOrderItemsFilters(state, param: Array<CriterionItemRequest>) {
      state.orderItemsFilter = param;
    },
    setDataTableOptions(state, param: DataOptions) {
      state.orderItemsDataOptions = param;
    },
    setOrderItemsCount(state, param: null | number) {
      state.orderItemsCount = param;
    },
    openOrderItemsPositionDialog(state, { orderItemId, position }) {
      state.orderItemPositionId = orderItemId;
      state.orderItemPositionCurrent = position;
      state.isOrderItemPositionDialog = true;
    },
    closeOrderItemsPositionDialog(state) {
      state.isOrderItemPositionDialog = false;
    },
    setIsOrderItemsLoading(state, param: boolean) {
      state.isOrderItemsLoading = param;
    },
    setIsViewLoading(state, param: boolean) {
      state.isViewLoading = param;
    },
    clearOrderMonit(state) {
      state.orderMonit = {
        items: [],
      };
    },
    setFormOfPayment(state, param: number) {
      if (state.orderSection) state.orderSection.formOfPaymentId = param;
    },
    setOrderMonit(state, param: { id: number; data: OrderMonit | null }) {
      if (!param.data || !param.id) return;

      // Clear state before add new items
      state.orderMonit.items = state.orderMonit.items.filter((x) => x.id != param.id);

      // Add items
      state.orderMonit.items.push({
        id: param.id,
        title: param.data.title ?? "",
        content: param.data.content ?? "",
        isVisible: param !== null,
      });

      state.orderMonit.items = state.orderMonit.items.sort((a, b) => a.id - b.id);
    },
    removeOrderMonit(state, id: number) {
      state.orderMonit.items = state.orderMonit.items.filter((x) => x.id != id);
    },
    setOrderId(state, param: string | null) {
      state.orderId = param;
    },
    setUnsavedChanges(state, param: boolean) {
      state.isUnsavedChanges = param;
    },
    setContractorAvailableProjects(state, param: null | Array<SelectItem>) {
      state.contractorAvailableProjects = param;
    },
    setIsImportBookingsDialog(state, param: boolean) {
      state.isImportBookingsDialog = param;
    },
    openImportBookingAttributesDialog(state, param: string) {
      state.isImportBookingAttributesDialog = true;
      state.orderItemIdToImportAttributes = param;
    },
    setIsImportBookingAttributesDialog(state, param: boolean) {
      state.isImportBookingAttributesDialog = param;
    },
    setIsUpdateOrderTemporaryProcessing(state, param: boolean) {
      state.isUpdateOrderTemporaryProcessing = param;
    },
    setBookingItemsToImport(state, param: Array<BookingItemToImport>) {
      state.bookingItemsToImport = param;
    },
    setIsBookingItemsConversionDialog(state, param: boolean) {
      state.isBookingItemsConversionDialog = param;
    },
    setIsPreview(state, param: boolean) {
      state.isPreview = param;
    },
    setIsServicePackageDialog(state, param: boolean) {
      state.isServicePackageDialog = param;
    },
    setCashiers(state, param: Array<Owner>) {
      state.cashiers = param;
    },
    setSaleDate(state, saleDate: string) {
      if (state.orderSection) state.orderSection.saleDate = saleDate;
    },
    setIssueDate(state, issueDate: string) {
      if (state.orderSection) state.orderSection.issueDate = issueDate;
    },
    setBankAccountId(state, bankAccountId: number) {
      if (state.orderSection) state.orderSection.bankAccountId = bankAccountId;
    },
    setBuyerSummaryPrint(state, buyerSummaryPrint: boolean) {
      if (state.buyer) state.buyer.summaryPrint = buyerSummaryPrint;
    },
    setChargeFromPayer(state, chargeFromPayer: boolean) {
      if (state.payer) state.payer.chargeFromCurrent = chargeFromPayer;
    },
    setChargeFromReceiver(state, chargeFromReceiver: boolean) {
      if (state.receiver) state.receiver.chargeFromCurrent = chargeFromReceiver;
    },
    setAttributesFromPayer(state, attributesFromPayer: boolean) {
      if (state.payer) state.payer.attributesFromCurrent = attributesFromPayer;
    },
    setAttributesFromReceiver(state, attributesFromReceiver: boolean) {
      if (state.receiver) state.receiver.attributesFromCurrent = attributesFromReceiver;
    },
    setContractorIsHidden(state, contractorIsHidden: boolean) {
      if (state.seller) state.seller.isHidden = contractorIsHidden;
    },
    setTab(state, tab: ORDER_CONTRACTOR_TABS) {
      state.tab = tab;
    },
  },
  actions: {
    async newOrder(context) {
      const { dispatch, commit } = _moduleActionContext(context);
      await store.dispatch.cashiersAndTraders.downloadCashiers();
      // noinspection ES6MissingAwait
      store.dispatch.cashiersAndTraders.downloadOfficeProfileCashiersAndTraders();
      const sessionId = await editOrder(null, ORDER_EDITOR_REASON.Create);
      commit.setSessionId(sessionId);
      commit.setOrderId(null);
      commit.setUnsavedChanges(false);
      commit.setIsPreview(false);
      // noinspection ES6MissingAwait
      await dispatch.downloadAll();
    },
    async cloneOrder(context, param: { orderId: string }) {
      const { rootDispatch } = _moduleActionContext(context);
      const confirm = new ConfirmModel(
        filterCapitalize(i18n.t("cloneOrderInfo")),
        filterCapitalize(i18n.t("warning")),
        [
          {
            text: filterCapitalize(i18n.t("cancel")),
            color: "warning",
            value: false,
            outlined: true,
          },
          {
            text: filterCapitalize(i18n.t("confirm")),
            color: "warning",
            value: true,
          },
        ],
        "500px"
      );
      const isConfirmed = await rootDispatch.popup.addConfirm(confirm);
      if (isConfirmed) {
        const clonnedOrderId = await cloneOrder(param.orderId);
        return clonnedOrderId;
      }
      return null;
    },
    async editOrder(context, param: { orderId: string; reason: ORDER_EDITOR_REASON }) {
      const { dispatch, commit } = _moduleActionContext(context);
      commit.setIsViewLoading(true);

      commit.setIsPreview(param.reason === ORDER_EDITOR_REASON.Preview);
      if (param.reason !== ORDER_EDITOR_REASON.Preview) await setTemporaryOnOrder(param.orderId, true);
      await store.dispatch.cashiersAndTraders.downloadCashiers();
      // noinspection ES6MissingAwait
      store.dispatch.cashiersAndTraders.downloadOfficeProfileCashiersAndTraders();

      const sessionId = await editOrder(param.orderId, param.reason).catch(() => {
        commit.setIsViewLoading(false);
      });

      if (typeof sessionId === "string") {
        commit.setSessionId(sessionId);
        commit.setOrderId(param.orderId);
        commit.setUnsavedChanges(false);
        // noinspection ES6MissingAwait
        await dispatch.downloadAll();
      } else {
        await setTemporaryOnOrder(param.orderId, false);
        await routerInstance.push({ name: "Orders" });
      }
    },
    async editDocument(context, param: { orderId: string; documentId: string }) {
      const { dispatch, commit } = _moduleActionContext(context);
      await setTemporaryOnOrder(param.orderId, true);
      await store.dispatch.cashiersAndTraders.downloadCashiers();
      // noinspection ES6MissingAwait
      store.dispatch.cashiersAndTraders.downloadOfficeProfileCashiersAndTraders();
      const sessionId = await editDocument(param.documentId).catch(() => null);

      if (typeof sessionId === "string") {
        commit.setSessionId(sessionId);
        commit.setOrderId(param.orderId);
        commit.setUnsavedChanges(false);
        // noinspection ES6MissingAwait
        await dispatch.downloadAll();
      } else {
        await setTemporaryOnOrder(param.orderId, false);
        await routerInstance.push({ name: "Documents" });
      }
    },
    async downloadAll(context) {
      const { dispatch, rootDispatch, commit } = _moduleActionContext(context);

      const timeout: null | number = setTimeout(() => {
        commit.setIsViewLoading(true);
      }, 100);

      await Promise.all([
        rootDispatch.attributes.downloadPrototypes(),
        dispatch.getTemporaryContractors(),
        dispatch.getTemporaryOrderItems(),
        dispatch.getTemporaryOwners(),
        dispatch.getTemporaryOrder(),
        dispatch.getTemporaryComment(),
        dispatch.getTemporaryContractorMonit(),
        dispatch.getTemporaryOrderItemMonit(),
        dispatch.getTemporaryCorrectionReason(),
      ]);

      await rootDispatch.downloadChangeReasons();

      clearTimeout(timeout);
      setTimeout(() => {
        commit.setIsViewLoading(false);
      }, 100);
    },
    async queryUpdateOrderTemporary(context, command: BaseCommand) {
      const { state, dispatch } = _moduleActionContext(context);
      if (!state.isPreview) {
        state.updateOrderTemporaryQuery.push(command);
        if (!state.isUpdateOrderTemporaryProcessing) {
          await dispatch.updateOrderTemporary();
        }
      }
    },
    async updateOrderTemporary(context) {
      const { state, dispatch, commit } = _moduleActionContext(context);
      if (state.updateOrderTemporaryQuery.length > 0) {
        commit.setIsUpdateOrderTemporaryProcessing(true);
        try {
          const command = state.updateOrderTemporaryQuery.shift() as BaseCommand;
          command.OperationId = state.operationId as string;
          command.SessionId = state.sessionId as string;
          let updateOrderTemporaryResponse;
          try {
            updateOrderTemporaryResponse = await updateOrderTemporary(command);
          } catch (e) {
            updateOrderTemporaryResponse = {
              operationId: state.operationId,
              reload: [
                RELOAD_TYPES.Contractors,
                RELOAD_TYPES.OrderItems,
                RELOAD_TYPES.Owners,
                RELOAD_TYPES.Order,
                RELOAD_TYPES.Comment,
                RELOAD_TYPES.CorrectionReason,
                RELOAD_TYPES.ContractorMonit,
                RELOAD_TYPES.OrderItemMonit,
              ],
              scrollToEndList: false,
              commandResponse: null,
            } as OperationResult;
            console.log(e);
          }
          if (
            updateOrderTemporaryResponse.commandResponse instanceof CommandResponseTradeTermIsPercentage &&
            updateOrderTemporaryResponse.commandResponse.tradeTermIsPercentage
          ) {
            // noinspection ES6MissingAwait
            dispatch.commands.updateTradeTerms(updateOrderTemporaryResponse.commandResponse.orderItemId);
          }
          commit.setUnsavedChanges(true);
          if (typeof updateOrderTemporaryResponse !== "undefined") {
            commit.setOperationId(updateOrderTemporaryResponse.operationId);
            for (const reloadOrder of updateOrderTemporaryResponse.reload) {
              if (reloadOrder === RELOAD_TYPES.Contractors) {
                // noinspection ES6MissingAwait
                dispatch.getTemporaryContractors();
              } else if (reloadOrder === RELOAD_TYPES.OrderItems) {
                // noinspection ES6MissingAwait
                dispatch.getTemporaryOrderItems(updateOrderTemporaryResponse.scrollToEndList);
              } else if (reloadOrder === RELOAD_TYPES.Owners) {
                // noinspection ES6MissingAwait
                dispatch.getTemporaryOwners();
              } else if (reloadOrder === RELOAD_TYPES.Order) {
                // noinspection ES6MissingAwait
                dispatch.getTemporaryOrder();
              } else if (reloadOrder === RELOAD_TYPES.Comment) {
                // noinspection ES6MissingAwait
                dispatch.getTemporaryComment();
              } else if (reloadOrder === RELOAD_TYPES.ContractorMonit) {
                // noinspection ES6MissingAwait
                dispatch.getTemporaryContractorMonit();
              } else if (reloadOrder === RELOAD_TYPES.OrderItemMonit) {
                // noinspection ES6MissingAwait
                dispatch.getTemporaryOrderItemMonit();
              } else if (reloadOrder === RELOAD_TYPES.CorrectionReason) {
                // noinspection ES6MissingAwait
                dispatch.getTemporaryCorrectionReason();
              }
            }
          }
        } finally {
          commit.setIsUpdateOrderTemporaryProcessing(false);
          if (state.updateOrderTemporaryQuery.length > 0) {
            // noinspection ES6MissingAwait
            await dispatch.updateOrderTemporary();
          }
        }
      }
    },
    async getTemporaryContractors(context) {
      const { commit, dispatch, state } = _moduleActionContext(context);
      if (state.operationId !== null) {
        const contractors = await getTemporaryContractors(state.operationId);
        commit.setPayer(contractors.payer);
        commit.setBuyer(contractors.buyer);
        commit.setReceiver(contractors.receiver);
        commit.setSeller(contractors.seller);
        commit.setOrganizationalUnit(contractors.organizationalUnit);
        dispatch.setContractor();
      }
    },
    async getTemporaryOrderItems(context, scrollToEndList: boolean | null | undefined = undefined) {
      const { commit, state, rootState } = _moduleActionContext(context);

      // const timeout: null | number = setTimeout(() => {
      //   commit.setIsOrderItemsLoading(true);
      // }, 50);
      commit.setIsOrderItemsLoading(true);
      if (state.operationId !== null) {
        let orderItems = await getTemporaryOrderItems(state.operationId, {
          criterions: state.orderItemsFilter,
          page: state.orderItemsDataOptions.page - 1,
          count: state.orderItemsDataOptions.itemsPerPage,
          filterName: FILTER_NAMES.OrderItemsInOrderFilter,
        });
        commit.setOrderItemsCount(orderItems.totalCount);
        if (scrollToEndList === true) {
          if (orderItems.totalCount > state.orderItemsDataOptions.page * state.orderItemsDataOptions.itemsPerPage) {
            const dataTableOptions = state.orderItemsDataOptions;
            dataTableOptions.page = Math.ceil(orderItems.totalCount / dataTableOptions.itemsPerPage);
            commit.setDataTableOptions(dataTableOptions);
            orderItems = await getTemporaryOrderItems(state.operationId, {
              criterions: state.orderItemsFilter,
              page: state.orderItemsDataOptions.page - 1,
              count: state.orderItemsDataOptions.itemsPerPage,
              filterName: FILTER_NAMES.OrderItemsInOrderFilter,
            });
          }
        }
        const response = await getUnavailableCashiers(state.operationId);
        let temp = _.clone(rootState.cashiersAndTraders.cashiers || []);
        if (response.length > 0) temp = temp.concat(response);
        commit.setCashiers(temp);
        commit.setOrderItems(orderItems);
      }

      commit.setIsOrderItemsLoading(false);
      // clearTimeout(timeout);
      // setTimeout(() => {
      //   commit.setIsOrderItemsLoading(false);
      // }, 500);
    },
    async getTemporaryOwners(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.operationId !== null) {
        const owners = await getTemporaryOwners(state.operationId);
        commit.setOwners(owners);
      }
    },
    async getTemporaryOrder(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.operationId !== null) {
        const orderSection = await getTemporaryOrder(state.operationId);
        commit.setOrderSection(orderSection);
      }
    },
    async getTemporaryComment(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.operationId !== null) {
        const response = await getTemporaryComment(state.operationId);
        commit.setComment(response);
      }
    },
    async getTemporaryContractorMonit(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.operationId !== null) {
        commit.removeOrderMonit(1);
        commit.removeOrderMonit(2);

        const monits = await getTemporaryContractorMonit(state.operationId);

        monits.forEach((monit) => {
          if (monit.type == CONTRACTOR_TYPES.Buyer) {
            commit.setOrderMonit({ id: 1, data: monit });
          }
          if (monit.type == CONTRACTOR_TYPES.Payer) {
            commit.setOrderMonit({ id: 2, data: monit });
          }
        });
      }
    },
    async getTemporaryOrderItemMonit(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.operationId !== null) {
        const monit = await getTemporaryOrderItemMonit(state.operationId);
        commit.setOrderMonit({ id: 3, data: monit });
      }
    },
    async getTemporaryCorrectionReason(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.operationId !== null) {
        const response = await getTemporaryCorrectionReason(state.operationId);
        commit.setInternalChangeReasonId(response.internalChangeReasonId);
        commit.setChangeReasonDescription(response.changeReasonDescription);
        commit.setFormalCorrectionBefore(response.formalCorrectionBefore);
        commit.setFormalCorrectionAfter(response.formalCorrectionAfter);
      }
    },
    async saveOrder(context, redirect = true): Promise<string | null> {
      const { rootDispatch, state, commit } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      if (state.operationId !== null) {
        const orderId = await postSaveOrder(state.operationId);
        commit.setUnsavedChanges(false);
        if (state.orderId === null && redirect) {
          await routerInstance.push({
            name: "Edit order",
            params: { id: orderId },
          });
        }
        return orderId;
      }
      return null;
    },
    async saveAndStay(context): Promise<void> {
      const { rootDispatch, state, commit, dispatch } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      if (state.operationId !== null) {
        if (state.orderId == null) await dispatch.saveOrder(true);
        else {
          await dispatch.commands.saveOrder();
          commit.setUnsavedChanges(false);
          rootDispatch.popup.addSavedOkSnackbar();
        }
      }
    },
    async checkRequireDataToGenerateOrder(context) {
      const { state } = _moduleActionContext(context);
      if (state.operationId !== null) {
        await checkRequireDataToGenerateDocument(state.operationId);
      }
    },
    async saveAndIssue(context) {
      const { rootDispatch, dispatch, state } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      await dispatch.checkRequireDataToGenerateOrder();
      let orderId = state.orderId;
      if (!orderId) orderId = await dispatch.saveOrder(true);
      else orderId = await dispatch.saveOrder(false);
      if (orderId) {
        await rootDispatch.orders.createDocument.issueDocument({
          orderId,
          timestamp: null,
        });
      }
    },
    async getContractorProjects(context) {
      const { state, commit } = _moduleActionContext(context);
      commit.setContractorAvailableProjects(null);
      if (state.operationId !== null) {
        const contractorProjects = await getContractorAvailableProjects(state.operationId);
        commit.setContractorAvailableProjects(
          contractorProjects.map((v) => ({ text: v.name, value: v.id } as SelectItem))
        );
      }
    },
    async importBookings(context) {
      const { commit, state, rootDispatch } = _moduleActionContext(context);
      if (state.operationId !== null) {
        commit.setBookingItemsToImport([]);
        const bookingItemsToImports = await getBookingItemsToConvert(state.operationId);
        commit.setBookingItemsToImport(bookingItemsToImports);
        for (const bookingItemToImport of bookingItemsToImports) {
          if (bookingItemToImport.isVisible) {
            commit.setIsBookingItemsConversionDialog(true);
            return;
          }
        }
        await rootDispatch.orderAddEdit.commands.importMarkedBookingItems();
      }
    },
    async setContractor(context) {
      const { state, commit } = _moduleActionContext(context);
      switch (state.tab) {
        case ORDER_CONTRACTOR_TABS.BUYER:
          commit.setContractor(state.buyer);
          break;
        case ORDER_CONTRACTOR_TABS.PAYER:
          commit.setContractor(state.payer);
          break;
        case ORDER_CONTRACTOR_TABS.RECEIVER:
          commit.setContractor(state.receiver);
          break;
        case ORDER_CONTRACTOR_TABS.SELLER:
          commit.setContractor(state.seller);
          break;
        case ORDER_CONTRACTOR_TABS.ORGANIZATION_UNIT:
          commit.setContractor(state.organizationalUnit);
          break;
      }
    },
  },
});

export default OrderAddEditModule;

/* eslint-disable */
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, OrderAddEditModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, OrderAddEditModule);
